import { render, staticRenderFns } from "./AppCardTitle.vue?vue&type=template&id=463608e1&scoped=true"
import script from "./AppCardTitle.vue?vue&type=script&lang=js"
export * from "./AppCardTitle.vue?vue&type=script&lang=js"
import style0 from "./AppCardTitle.vue?vue&type=style&index=0&id=463608e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463608e1",
  null
  
)

export default component.exports